<section class="card">


  <div class="card-header">
    <span class="cat__core__title">
      <strong>Questionnaire Setup</strong>
    </span>
  </div>


  <div class="card-block watermark">
    <div class="row">
      <div class="col-lg-12">
        <form [formGroup]="entityForm" class="well" autocomplete="off">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-2">
              </div>
              <div class="col-md-4">
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label" for="l0">Select Entity
                  <span style="color: red;">*</span>
                </label>
              </div>
              <div class="form-group  col-lg-10">
                <select class="form-control" [formControl]="entityForm.controls['evaluationType']" name="evaluationType"
                  [(ngModel)]="evaluationType" style="padding:6px;">
                  <!--(change)="getEvaluationCriteriaByEvalIdList(evaluationType)"-->
                  <option [ngValue]="undefined" selected [disabled]="true">select</option>
                  <option *ngFor="let evalType of evaluationTypeList" value="{{evalType._id}}">
                    {{evalType.EvaluationType}}</option>
                </select>
                <div
                  *ngIf="entityForm.controls['evaluationType'].hasError('required') && entityForm.controls['evaluationType'].touched"
                  class="form-control-error-custom p-0 mt-1">
                  Entity is required.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label">Evaluation Questionnaire Name
                  <span style="color: red;">*</span>
                </label>
              </div>
              <div class="col-lg-10">
                <div class="form-group">
                  <input class="form-control" type="text" placeholder=" Evaluation Questionnaire Name"
                    (keyup)="evaluationNameChangeEvent($event)" (change)="evaluationNameChangeEvent($event)"
                    name="evaluationName" [formControl]="entityForm.controls['evaluationName']"
                    [(ngModel)]="evaluationName">
                  <div
                    *ngIf="entityForm.controls['evaluationName'].hasError('required') && entityForm.controls['evaluationName'].touched"
                    class="form-control-error-custom">
                    Evaluation Questionnaire Name is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label">Risk Matrix:
                  <span style="color: red;">*</span>
                </label>
              </div>
              <div class="ml-3 mt-1">
                <div class="toggle-switch-group">
                  <span class="toggle-label mb-1">3X3</span>
                  <label class="switch">
                    <input type="checkbox" name="numOption" [checked]="entityForm.get('selectedValue').value == 5"
                      (change)="toggleRiskMatrix($event)">
                    <span class="slider"></span>
                  </label>
                  <span class="toggle-label mb-1">5X5</span>

                </div>

                <select class="form-control" [formControl]="entityForm.controls['risk-matrix']" name="risk-matrix"
                  style="padding:6px;">
                  <!--(change)="getEvaluationCriteriaByEvalIdList(evaluationType)"-->
                  <option [ngValue]="undefined" selected [disabled]="true">select</option>
                  <option *ngFor="let matrix of matrixList" value="{{matrix._id}}">
                    {{matrix.MatrixName}}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label">Score Range
                  <span style="color: red;">*</span>
                </label>
              </div>
              <div class="ml-3 mt-1">2</div>

              <div class="col-lg-3 ml-2 p-0">
                <div class="form-group">
                  <div class="form-control-error-custom"></div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label">Score Particulars
                  <span style="color: red;">*</span>
                </label>
              </div>
              <div formGroupName="arrayOfScoreParticular" class="row col-lg-10">
                <div style="display: inline-flex;margin-top: 2%;">
                  <label style="margin-left:5%">Probablity (in %)</label> <input style="margin-left:8%"
                    formControlName="Probablity" class="form-control" type="number" placeholder="in % (1%-100%)"
                    id="Probablity" required="required" readonly>
                </div>
                <div style="display: inline-flex;margin-top: 2%;">
                  <label style="margin-left:5%">Impact (in ₹)</label> <input style="margin-left:8%"
                    formControlName="Impact" class="form-control" type="number" placeholder="in ₹ (1-1000000)"
                    id="Impact" required="required" readonly>
                </div>
              </div>
              <!-- <div formGroupName="arrayOfScoreParticular" class="row col-lg-10">
                <div *ngFor="let item of arrayOfScoreParticular; let i = index;">
                  <div style="display: inline-flex;margin-top: 2%;">
                    <label style="margin-left:5%">{{(i+1
                      < 10 ) ? ( "0" + (i+1)) : i+1}}</label> <input style="margin-left:5%"
                          formControlName="{{item.scoreParticulars}}" class="form-control" type="text"
                          placeholder="text" id="{{item.scoreParticulars}}" required="required"
                          (change)="scoreParticularsValue($event,i+1)">
                  </div>
                  <div style="margin-left:5%"
                    *ngIf="entityForm.controls.arrayOfScoreParticular.controls[item.scoreParticulars].hasError('required') && entityForm.controls.arrayOfScoreParticular.controls[item.scoreParticulars].touched "
                    class="form-control-error-custom">
                    {{(((i+1)
                    < 10 ) ? ( "0" + (i+1)) : (i+1)) + " " }}Score Particular is required </div>
                      <div style="margin-left:5%"
                        *ngIf="entityForm.controls.arrayOfScoreParticular.controls[item.scoreParticulars].hasError('sameScoreParticular') && entityForm.controls.arrayOfScoreParticular.controls[item.scoreParticulars].touched "
                        class="form-control-error-custom">
                        {{(((i+1)
                        < 10 ) ? ( "0" + (i+1)) : (i+1)) + " " }}Same Score Particular entered </div>

                      </div> -->


            </div> <br>
            <div class="row">
              <div class="col-lg-2">
                <label class="form-control-label">Is Anonymous</label>
                <span style="color: red;">*</span>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label class="form-check-label">
                    <input type="radio" [formControl]="entityForm.controls['isAnonymous']" style="position:absolute"
                      name="isAnonymous" value="true" class="form-check-input">Yes</label>
                  <label class="form-check-label">
                    <input type="radio" [formControl]="entityForm.controls['isAnonymous']" style="position:absolute"
                      name="isAnonymous" value="false" class="form-check-input">No</label>

                  <div
                    *ngIf="entityForm.controls['isAnonymous'].hasError('required') && entityForm.controls['isAnonymous'].touched"
                    class="form-control-error-custom">
                    IsAnonymous is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span>Select Risk Description</span>
                <span style="color: red;">*</span>
              </div>
              <!-- <span *ngIf="selectedAssessmentType=='RFactor'" style="color: red">Note: Please select 'Relative' and 'Response' Category for execution of R-Factor</span> -->
              <br>
              <div class="col-lg-10">
                <div class="margin-bottom-50"></div>
                <div style="position:relative">
                  <div class="col-lg-12 ver-scroll"
                    style="position:relative; overflow-y: scroll; height: 170px;overflow-x: hidden; border: 1px solid rgba(0,0,0,.125); padding-top: 15px;">
                    <div class="row form-group">
                      <div class="col-lg-3" *ngFor="let criteria of criterias">
                        <div class="row">
                          <div class="col-lg-8">
                            <label class="form-check-label custom-tooltip">
                              <input id="{{criteria._id}}" [disabled]="criteria.isEnable"
                                [formControl]="entityForm.controls['criteriaName']" name="criteriaName" type="checkbox"
                                value="{{criteria._id}}" (change)="checkSelectedCriteria($event)">
                              <span class="">{{criteria.EvaluationCriteria}}</span>
                            </label>
                          </div>
                          <div class="col-lg-1" style="padding: 5px 0px">
                          </div>
                          <!-- % -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-lg-9"></div>
              <div class="col-lg-3" style="text-align:right">
                <button class="btn btn-sm btn-primary" type="submit" (click)="saveCriteria()"
                  [disabled]="criteriaIsEmpty">Save
                  Risk Description</button>
              </div>
            </div>
            <div class="row">
              <div>
                <span>Risk Description List</span>
              </div>
              <!-- <input type="checkbox" id="equalCriteriaCheck" [checked]="equalCriteria" (click)="onEqualcriteria()" /> -->

              <input id="equalCriteriaCheck" type="checkbox" [checked]="equalCriteria" (click)="onEqualcriteria()"
                style="display: block;margin-left: 35px;margin-right: 5px; position: relative; bottom: 7px;">
              Equal weights to all risk description
              <div *ngIf="evaluationFormId != undefined" style="margin-top: 20px;">Important:- &nbsp; Please press
                update and save all criterias once to load old values or to update them</div>
              <div class="table-responsive table-bordered margin-bottom-50">
                <table datatable id="selectedCriteriatable" [dtTrigger]="dtTrigger"
                  class="table table-hover compact cell-border nowrap table-striped dataTable"
                  style="background:transparent" width="100%">
                  <thead>
                    <tr>
                      <th style="width:60%">Risk Description Name</th>
                      <th style="width:10%">Risk Description Weight(%)</th>
                      <th style="width:5%">Select Question</th>
                      <th style="width:5%">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr><th>Dept Name:</th></tr> -->
                    <tr *ngFor="let selectedCriteria of selectedCriteriaListData; let i = index">
                      <td style="width: 60%;">
                        <button (click)="toggleCriteria(selectedCriteria._id)"
                          style="background-color: #37669e; color: #fff; border: unset;">
                          <i class="fa"
                            [ngClass]="expandedCriteriaId === selectedCriteria._id ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                        </button>
                        &nbsp;<b> {{ selectedCriteria.EvaluationCriteria }} &nbsp; : </b>

                        <div class="toggle-panel" *ngIf="expandedCriteriaId === selectedCriteria._id">
                          <!-- Display only questions of the selected criteria here -->
                          <table>
                            <thead>

                            </thead>
                            <tbody>
                              <ng-container *ngFor="let dept of (groupedByDepartment[selectedCriteria._id] | keyvalue)">
                                <tr>
                                  <td colspan="7" style="background:#f9fafc;">
                                    <button (click)="toggledept(dept.key)"
                                      style="background-color: #37669e; color: #fff; border: unset;">
                                      <i class="fa"
                                        [ngClass]="qId === dept.key ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                    </button>
                                    Dept: - {{dept.value.RiskDepartment}}
                                  </td>
                                </tr>
                                <tr *ngIf="qId === dept.key">
                                  <td colspan="7">
                                    <table style="width:100%;">
                                      <tbody>
                                        <!-- Now, loop through each question and print its title AND table together -->
                                        <ng-container *ngFor="let deptQuestion of dept.value.Questions">
                                          <!-- Question Header -->
                                          <tr>
                                            <th colspan="7" style="padding-top: 10px;"><b>{{ deptQuestion.Question
                                                }}</b></th>
                                          </tr>
                                          <!-- Table headers -->
                                          <tr>
                                            <th></th>
                                            <th *ngIf="selectedValue == 5">Trivial</th>
                                            <th>Low</th>
                                            <th>Med</th>
                                            <th>High</th>
                                            <th *ngIf="selectedValue == 5">Crucial</th>
                                            <th>Risk Owner</th>
                                          </tr>
                                          <!-- Impact row, with Risk Owner only ONCE -->
                                          <tr>
                                            <td><b>Impact (in ₹)</b></td>
                                            <td *ngIf="selectedValue == 5">{{ deptQuestion.TrivialImpact }}</td>
                                            <td>{{ deptQuestion.LowImpact }}</td>
                                            <td>{{ deptQuestion.MediumImpact }}</td>
                                            <td>{{ deptQuestion.HighImpact }}</td>
                                            <td *ngIf="selectedValue == 5">{{ deptQuestion.CriticalImpact }}</td>
                                            <td rowspan="2" style="vertical-align: middle; text-align: center;">
                                              {{ deptQuestion.RiskOwnerName }}
                                            </td>
                                          </tr>
                                          <!-- Probability row, NO Risk Owner cell -->
                                          <tr>
                                            <td><b>Probability (in %)</b></td>
                                            <td *ngIf="selectedValue == 5">{{ deptQuestion.TrivialProbability }}</td>
                                            <td>{{ deptQuestion.LowProbability }}</td>
                                            <td>{{ deptQuestion.MediumProbability }}</td>
                                            <td>{{ deptQuestion.HighProbability }}</td>
                                            <td *ngIf="selectedValue == 5">{{ deptQuestion.CriticalProbability }}</td>
                                            <!-- No <td> in this row for Risk Owner -->
                                          </tr>
                                        </ng-container>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </ng-container>


                            </tbody>
                          </table>
                        </div>
                      </td>

                      <td style="width: 10%">
                        <div>
                          <input type="number" step="0.25" min="0.25" [(ngModel)]="selectedCriteria.criteriaWeight"
                            name="categoryWeightage" [formControl]="entityForm.controls['categoryWeightage']"
                            class="form-control" [readOnly]="equalCriteria"
                            (change)="categoryWeightCalculation(countindex,selectedCriteria.criteriaWeight)">
                        </div>
                      </td>
                      <td style="width: 5%;text-align: center;">
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="showCriteriaQuetionsPopup(selectedCriteria)">{{selectedNameToShow(selectedCriteria)
                          ? "Select" : "Update"}}</button>
                        <!-- <button type="button" class="btn btn-sm btn-primary" *ngIf="questionListIsNotEmpty" (click)="showCriteriaQuetionsPopup(selectedCriteria)">Update</button>-->
                      </td>
                      <td style="width: 5%;text-align: center; color: #74708d; cursor:pointer;vertical-align:middle">
                        <div class="icmn-bin" (click)="confirmDeleteCriteria(selectedCriteria._id)"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div *ngIf="greaterCriteriaWeight || invalidCriteriaWeight"
                  style="float:right;color: #fb434a;font-size: 80%;z-index: 1;">
                  <!-- Total Category weight must be 100. -->
                  Sum of risk description weight should be equal 100%.
                </div>
                <!-- <div *ngIf="invalidCriteriaWeight" style="float:right;color: #fb434a;font-size: 80%;z-index: 1;">
                    No of selected categories and total weight should be equal.
                  </div> -->
              </div>
            </div>
            <br>

            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-sm btn-primary" *ngIf="!isAssigned" style="float:right" [disabled]="!(!(sendEntityFormForReview) && (entityForm.valid) && !(greaterCriteriaWeight) && !(invalidCriteriaWeight))"
                    (click)="submitEntity()">Send For Review</button> 
                    
                    [disabled]="!(!(sendEntityFormForReview) && (entityForm.valid)  && !(greaterCriteriaWeight) && !(invalidCriteriaWeight))  || disableSavebutton"
                    -->
              <button type="button" class="btn btn-sm btn-primary" style="float:right"
                [disabled]="!(!(sendEntityFormForReview) && (entityForm.valid)  && !(greaterCriteriaWeight) && !(invalidCriteriaWeight))  || disableSavebutton"
                (click)="sendForReview()">Save to Questionnaire Bank</button>
            </div>
          </div>
          <!--[disabled]="!entityForm.valid"-->
        </form>
        <!--question dialogbox-->
        <div class="modal fade modal-size-large " id="EntityQuestionSetup" tabindex="-1" role="dialog"
          aria-labelledby="" aria-hidden="true" style="display: none;">
          <div class="modal-dialog modal-lg" role="document" style="max-width: 90%; width: auto;">
            <div class="modal-content">

              <div class="modal-header">
                <h5 class="modal-title" id="Header">Select Risk Description Questions</h5>
                <button type="button" class="close " style="right:5px; position:absolute; margin-right: 10px;"
                  data-dismiss="modal" (click)="closeForm('EntityQuestionSetup')" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div>
                  <!--|| (selectedAssessmentType=='RFactor' && categoryName!='Relative' && categoryName!='Ratings')"> -->
                  <div class="form-group">
                    <div class="row">
                      <div class="col-lg-12">
                        <label class="form-control-label col-sm-12" style="font-weight: bold;">Questions
                          selected</label>
                        <div class="cat__core__widget cat__core__widget--border">
                          <div
                            style="max-height:200px;width: 100%!important; min-height: 100px; overflow-y: auto;float: left;">
                            <table class="table table-hover nowrap table-striped dataTable "
                              style="margin: 0px !important;">
                              <thead>
                                <tr>
                                  <th style="padding: 2px 10px; width:4%;">
                                    <!-- <input type="checkbox" id="chkTagsAll" title="Select All" (change)="question_Changed($event)" name="TagsQ"> -->
                                  </th>
                                  <th style="padding: 2px 10px; width:86%;">Question List</th>
                                </tr>
                              </thead>
                              <tbody style="border-bottom: 1px solid #e4e9f0;">
                                <ng-container *ngFor="let group of groupedQuestions; let i = index">
                                  <tr>
                                    <td colspan="2" style="font-weight:600; padding: 8px 10px; background: #f9fafb">
                                      <span style="cursor:pointer; margin-right:12px;"
                                        (click)="toggleDepartment(group.department)">
                                        <!-- Use a simple text for expand/collapse symbol; replace with icons as needed -->
                                        <span *ngIf="!expandedDepartments[group.department]">&#9654;</span> <!-- ▶ -->
                                        <span *ngIf="expandedDepartments[group.department]">&#9660;</span> <!-- ▼ -->
                                      </span>
                                      Department: {{group.department}}
                                    </td>
                                  </tr>
                                  <ng-container *ngIf="expandedDepartments[group.department]">
                                    <tr *ngFor="let question of group.questions">
                                      <td style="padding: 2px 10px; width:68%;" colspan="2">
                                        <label style="cursor: pointer; display: flex; align-items: center; gap: 44px;">
                                          <input type="checkbox" [id]="question._id" [checked]="question.isChecked"
                                            (change)="question_Changed($event)" name="TagsQ" [value]="question._id">
                                          <span style="white-space: normal;">{{question.QuestionText}}</span>
                                        </label>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </ng-container>
                              </tbody>


                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--arrows up and down-->
                    <div>
                      <div class="col-lg-12" style="padding: 0px;">
                        <div class="row pb-3 pt-3">
                          <div class="col-lg-6" style="text-align: right;">
                            <button title="Add question!" id="AddQuestions" type="button" class="btn btn-sm btn-primary"
                              (click)="addQuestions()">
                              <i class="fa fa-chevron-down"></i>
                            </button>
                          </div>
                          <div class="col-lg-6">
                            <button title="Remove question!" id="RemoveQuestions" type="button"
                              class="btn btn-sm btn-primary" (click)="removeQuestions()">
                              <i class="fa fa-chevron-up"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--selected quetions-->
                    <div>
                      <table class="table table-hover nowrap dataTable table-striped" style="margin: 0px !important;">
                        <!-- || (selectedAssessmentType=='RFactor' && categoryName!='Ratings')"> -->
                        <thead>
                          <tr>
                            <th style="width:4%; padding:6px;"></th>
                            <th style="width:40%; padding:6px; text-align:left;">Selected Questions</th>
                            <th style="width:8%; padding:6px; text-align:center;"></th>
                            <th style="width:8%; padding:6px; text-align:center;" *ngIf="selectedValue == 5">Trivial
                            </th>
                            <th style="width:8%; padding:6px; text-align:center;">Low</th>
                            <th style="width:8%; padding:6px; text-align:center;">Medium</th>
                            <th style="width:8%; padding:6px; text-align:center;">High</th>
                            <th style="width:8%; padding:6px; text-align:center;" *ngIf="selectedValue == 5">Critical
                            </th>
                            <th style="width:10%; padding:6px; text-align:center;">Risk Owner</th>
                          </tr>
                        </thead>

                        <tbody style="border-bottom: 1px solid #e4e9f0; overflow: overlay;">
                          <ng-container *ngFor="let selectedQuestion of selectedQuestionsList; let j = index">
                            <!-- Impact row -->
                            <tr>
                              <td>
                                <input type="checkbox" id="{{selectedQuestion._id}}"
                                  [checked]="selectedQuestion.isChecked" name="selectQ"
                                  (change)="selectedQuestionCheckboxChange(selectedQuestion, $event)" />
                              </td>

                              <!-- Question text -->
                              <td style="white-space: normal; padding:6px;">
                                <label class="form-control-label custom-tooltip">
                                  <span>{{ selectedQuestion.QuestionText }}</span>
                                </label>
                              </td>

                              <!-- Impact label -->
                              <td class="impact-label" style="text-align:center; padding:6px;">
                                Impact (in ₹)
                              </td>

                              <!-- Impact: Trivial -->
                              <td class="risk-cell" *ngIf="selectedValue == 5">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.trivialImpact"
                                  (ngModelChange)="onImpactChange($event, selectedQuestion, 'trivialImpact')"
                                  name="trivialImpact{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.trivialImpact && !isValidImpact(selectedQuestion.trivialImpact)}" />

                                <div
                                  *ngIf="selectedQuestion.trivialImpact && !isValidImpact(selectedQuestion.trivialImpact)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Impact: Low -->
                              <td class="risk-cell">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.lowImpact"
                                  (ngModelChange)="onImpactChange($event, selectedQuestion, 'lowImpact')"
                                  name="lowImpact{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.lowImpact && !isValidImpact(selectedQuestion.lowImpact)}" />

                                <div *ngIf="selectedQuestion.lowImpact && !isValidImpact(selectedQuestion.lowImpact)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Impact: Medium -->
                              <td class="risk-cell">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.mediumImpact"
                                  (ngModelChange)="onImpactChange($event, selectedQuestion, 'mediumImpact')"
                                  name="mediumImpact{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.mediumImpact && !isValidImpact(selectedQuestion.mediumImpact)}" />

                                <div
                                  *ngIf="selectedQuestion.mediumImpact && !isValidImpact(selectedQuestion.mediumImpact)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Impact: High -->
                              <td class="risk-cell">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.highImpact"
                                  (ngModelChange)="onImpactChange($event, selectedQuestion, 'highImpact')"
                                  name="highImpact{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.highImpact && !isValidImpact(selectedQuestion.highImpact)}" />

                                <div *ngIf="selectedQuestion.highImpact && !isValidImpact(selectedQuestion.highImpact)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Impact: Critical -->
                              <td class="risk-cell" *ngIf="selectedValue == 5">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.criticalImpact"
                                  (ngModelChange)="onImpactChange($event, selectedQuestion, 'criticalImpact')"
                                  name="criticalImpact{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.criticalImpact && !isValidImpact(selectedQuestion.criticalImpact)}" />

                                <div
                                  *ngIf="selectedQuestion.criticalImpact && !isValidImpact(selectedQuestion.criticalImpact)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>


                              <!-- Risk Owner (spans Impact+Probability rows) -->
                              <td rowspan="2"
                                style="padding:6px; text-align:center; vertical-align: middle; min-width: 180px;">
                                <ng-select class="risk-select ng-select-stretch" [items]="userListToBind"
                                  bindLabel="FullName" bindValue="_id" [(ngModel)]="selectedQuestion.selectedUserToSend"
                                  [multiple]="false" placeholder="Select">
                                  <ng-option *ngFor="let user of userListToBind" [value]="user._id">
                                    {{user.FirstName}} {{user.LastName}}
                                  </ng-option>
                                </ng-select>
                              </td>


                              <!-- Probability row -->
                            <tr>
                              <td></td> <!-- empty: checkbox column -->
                              <td></td> <!-- empty: question column -->
                              <td class="impact-label" style="text-align:center; padding:6px;">Probability (in %)</td>

                              <!-- Probability: Trivial -->
                              <td style="padding:6px; text-align:center;" *ngIf="selectedValue == 5">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.trivialProbability"
                                  (ngModelChange)="onProbabilityChange($event, selectedQuestion, 'trivialProbability')"
                                  name="trivialProbability{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.trivialProbability && !isValidProbability(selectedQuestion.trivialProbability)}" />
                                <div
                                  *ngIf="selectedQuestion.trivialProbability && !isValidProbability(selectedQuestion.trivialProbability)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Probability: Low -->
                              <td style="padding:6px; text-align:center;">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.lowProbability"
                                  (ngModelChange)="onProbabilityChange($event, selectedQuestion, 'lowProbability')"
                                  name="lowProbability{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.lowProbability && !isValidProbability(selectedQuestion.lowProbability)}" />
                                <div
                                  *ngIf="selectedQuestion.lowProbability && !isValidProbability(selectedQuestion.lowProbability)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                              <!-- Probability: Medium -->
                              <td style="padding:6px; text-align:center;">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.mediumProbability"
                                  (ngModelChange)="onProbabilityChange($event, selectedQuestion, 'mediumProbability')"
                                  name="mediumProbability{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.mediumProbability && !isValidProbability(selectedQuestion.mediumProbability)}" />
                                <div
                                  *ngIf="selectedQuestion.mediumProbability && !isValidProbability(selectedQuestion.mediumProbability)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>


                              <!-- Probability: High -->
                              <td style="padding:6px; text-align:center;">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.highProbability"
                                  (ngModelChange)="onProbabilityChange($event, selectedQuestion, 'highProbability')"
                                  name="highProbability{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.highProbability && !isValidProbability(selectedQuestion.highProbability)}" />
                                <div
                                  *ngIf="selectedQuestion.highProbability && !isValidProbability(selectedQuestion.highProbability)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>


                              <!-- Probability: Critical -->
                              <td style="padding:6px; text-align:center;" *ngIf="selectedValue == 5">
                                <input class="risk-input" type="text" maxlength="6"
                                  [ngModel]="selectedQuestion.criticalProbability"
                                  (ngModelChange)="onProbabilityChange($event, selectedQuestion, 'criticalProbability')"
                                  name="criticalProbability{{j}}"
                                  [ngClass]="{'invalid-input': selectedQuestion.criticalProbability && !isValidProbability(selectedQuestion.criticalProbability)}" />
                                <div
                                  *ngIf="selectedQuestion.criticalProbability && !isValidProbability(selectedQuestion.criticalProbability)"
                                  class="validation-error">
                                  Only 1–100, &lt;, &gt;, = or ranges allowed
                                </div>
                              </td>

                            </tr>
                          </ng-container>
                        </tbody>


                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button id="Save" type="button" class="btn btn-sm btn-primary" [disabled]="selectedQuestionListEmpty"
                  (click)="saveSelectedQuestions()">Save</button>
                <!-- <button id="Update" style="display:none;" type="button" class="btn btn-sm btn-primary">Update</button> -->
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                  (click)="cancleSelectedQuestionList()">Cancel</button>
              </div>

            </div>
          </div>
        </div>

        <!--delete criteria-->
        <div class="modal fade" id="criteriaDeletionMessageModal" role="dialog"
          aria-labelledby="criteriaDeletionMessageModal">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="criteriaDeletionMessageModal">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p>Are you sure you want to delete this risk description?</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="deleteCriteria()">Confirm </button>
                <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
                  (click)="closeForm('criteriaDeletionMessageModal')">Cancel</button>
              </div>
            </div>
          </div>
        </div>

        <!--save review dialog-->
        <div class="modal fade" id="saveReviewDialogBox" role="dialog" aria-labelledby="saveReviewDialogBox">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="saveReviewDialogBox">
                  <i class=" mr-2"></i>Send For Review
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <ng-select [items]="userListToBind" (selected)="userSelected($event)" placeholder="Select reviewers"
                  [ngModel]="selectedUsers" (deselected)="multipleUserDeselection($event)" [multiple]="true">
                </ng-select>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" [disabled]="!enableSaveButton"
                  (click)="sendForReview()">Send</button>
                <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
                  (click)="closeForm('saveReviewDialogBox')">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>